/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function UsersIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="users"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <circle cx={9.592} cy={9.5} r={4.408} stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16.056 5.342A4.408 4.408 0 0 1 16.056 13.658" data-tinysvg-shape="arc" data-tinysvg-arc="14.592 9.5 4.408 4.408 289.392 70.608 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.592 20.583A6.893 6.893 0 0 1 15.592 20.583" data-tinysvg-shape="arc" data-tinysvg-arc="9.592 23.977 6.893 6.893 209.496 330.504 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15.007 16.582C15.2 16.565 15.396 16.557 15.592 16.557C18.076 16.557 20.369 17.894 21.592 20.056" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
